import { render, staticRenderFns } from "./MindmapSales.pug?vue&type=template&id=c2b35f82&lang=pug&external"
import script from "./MindmapSales.js?vue&type=script&lang=js&external"
export * from "./MindmapSales.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports